export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/en.lyaml"));
at({ "en": { "public": { "sampleString": "Sample string" } } });
};